import { useEffect, useState } from "react";
import axios from "axios";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Manifesto from "../components/Manifesto";
import Expect from "../components/Expect";
import Instructor from "../components/Instructor";
import Pricing from "../components/Pricing";
import Testimonials from "../components/Testimonials";
import Booking from "../components/Booking";
import Footer from "../components/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Home() {
  const [config, setConfig] = useState({ pricing: [], acuity_embed_url: "" });

  useEffect(() => {
    axios.get(`${API}/config`).then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  return (
    <main className="bg-[#FAF7F2]">
      <Nav />
      <Hero />
      <Marquee />
      <Manifesto />
      <Expect />
      <Instructor />
      <Pricing plans={config.pricing} />
      <Testimonials />
      <Booking />
      <Footer />
    </main>
  );
}
